import { useFormik } from "formik";
import CustomAlert from "@components/Shared/Alert/CustomAlert";
import Select from "react-select";
import { Card } from "@components/card/card";
import { CardBody, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Breadcrumb from "@components/Shared/Breadcrumb";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import {
  updateUpdateCostTransactions,
  getUpdateCostTransactionsById,
} from "@store/INV/Transactions/UpdateCost/InvUpdateCostSlice";
import { useNavigate, useParams } from "react-router-dom";
import { TreeSelect } from "antd";
import Loading from "@components/Shared/Loader/Loading";
import useGetSubinventoryList from "@hooks/INV/Inventories/useGetSubinventoryList";
import useGetInventoryWithPermission from "@hooks/NTX/Organization/useGetInventoryWithPermission";
// import useGetBranchOrgWithPermission from '@hooks/NTX/Organization/useGetBranchOrgWithPermission';
// import NeatixModal from "@components/Modal/NeatixModal";
import { useEffect, useState } from "react";
import { getPersonId } from "@store/Login/authSelectors";
import useGetTransactionTypesList from "@hooks/INV/TransactionTypes/useGetTransactionTypesList";
import UpdateCostLines from "./UpdateCostLines";
import useGetOperatingUnitWithPermission from "@hooks/NTX/Organization/useGetOperatingUnitWithPermission";

const Update = () => {
  const { id } = useParams();
  // const [showModal, setShowModal] = useState(true);
  // const [inventory, setInventory] = useState<any>(null);

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const { InventoryOptions, loading: loading4 } =
    useGetInventoryWithPermission();
  const { loading: loading1, TreeSubInventoryData } = useGetSubinventoryList();

  const {
    OptionsTransactionTypes,
    loading: loading5,
    error,
  } = useGetTransactionTypesList();

  const {
    OperatingUnitOptions,
    loading: loading6,
    error: error6,
  } = useGetOperatingUnitWithPermission();
  const personId = useAppSelector(getPersonId);

  useEffect(() => {
    if (id) {
      dispatch(getUpdateCostTransactionsById(id));
    }
  }, [dispatch, id]);
  const { UpdateCostById: data } = useAppSelector((s) => s.InvUpdateCost);

  //#region Formik
  const formik = useFormik({
    initialValues: {
      // code: "AVC", // تحديث سعـــر التكلــفة
      code: data.code ?? "",
      transactionDate: data.transactionDate ?? "",
      description: data.description ?? "",
      branchId: data.branchId ?? "",
      transactionAmount: data.transactionAmount ?? 0,
      referenceType: data.referenceType ?? "",
      referenceId: data.referenceId ?? "",
      supplierId: data.subInventoryId ?? null,
      customerId: data.customerId ?? null,
      personId: data.personId ?? personId,
      subInventoryId: data.subInventoryId ?? null,
      inventoryId: data.inventoryId ?? "",
      address: data.address ?? "",
      note: data.note ?? "",
      // transactionYear: data.tran/ 0,
      materialTransactionsLineList: data.materialTransactionsLineList?.map(
        (item) => ({
          id: item.id ?? null, //
          transactionItemId: item.transactionItemId ?? null,
          transactionUom: item.transactionUom ?? "",
          unitPrice: item.unitPrice ?? 0,
          transactionQuantityIn: item.transactionQuantityIn ?? 0,
          transactionQuantityOut: item.transactionQuantityOut ?? 0,
          lotId: item.lotId ?? null,
          // inventoryId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
          // discount: 0,
          // codeCombinationId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
          // currencyCode: 'string',
          // currencyConversionRate: 0,
          // referenceIdMaster: "",
          // referenceIdLine: "",
          // transactionTypeId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
          // equivalent: 0,
          // expensesAmount: 0,
          // batchId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        })
      ),
    },
    enableReinitialize: true,
    // validationSchema: AddIssueTransactionsSchema(t),
    onSubmit: (values) => {
      dispatch(
        updateUpdateCostTransactions({
          id: data.id || null,
          code: values.code,
          transactionDate: values.transactionDate,
          description: values.description,
          branchId: values.branchId,
          transactionAmount: 0,
          referenceType: values.code,
          referenceId: values.referenceId || null,
          supplierId: null,
          customerId: null,
          personId: values.personId || null,
          inventoryId: values.inventoryId,
          address: values.address,
          note: values.note,
          transactionYear: 0,
          subInventoryId: values.subInventoryId,
          materialTransactionsLineList:
            formik.values.materialTransactionsLineList?.map((item) => ({
              id: item.id, //
              transactionItemId: item.transactionItemId,
              transactionUom: item.transactionUom,
              unitPrice: item.unitPrice, // item.price
              // unitPrice: 0, // item.price
              transactionQuantityIn: item.transactionQuantityIn,
              transactionQuantityOut: 0,
              lotId: item.lotId || null,
              inventoryId: null,
              referenceIdMaster: null,
              referenceIdLine: null,
              transactionTypeId: null,
              equivalent: 0,
              expensesAmount: 0,
            })),
        })
      )
        .unwrap()
        .then((res: any) => {
          // debugger;
          if (res?.succeeded === true) {
            CustomAlert({ action: "Add" });
            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: "Error", msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: "Error" });
        });
    },
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;
  //#endregion

  //____________________________
  const BcrumbList = [
    {
      name: "Home",
      link: ":moduleHome",
    },
    {
      name: "Update Cost",
      link: "/INV/Transactions/UpdateCost",
    },
    {
      name: "Add Update Cost",
      link: null,
    },
  ];

  return (
    <>
      <Breadcrumb
        BreadcrumbList={BcrumbList}
        PageName="Update Cost"
        subtitle={
          InventoryOptions?.find((f: any) => f.value === values.inventoryId)
            ?.label
        }
      />

      <Card>
        <Loading
          loading={loading6 || loading4 || loading5 || loading1}
          error={error}
        >
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <div className="row ">
                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t("الرقم")}</label>
                    <Form.Control
                      className="form-control text-center"
                      type="text"
                      name="code"
                      onChange={formikhandleChange}
                      value={values.code || ""}
                      // isInvalid={!!(touched.transactionDate && errors.transactionDate)}
                    />
                    {/* <div className="text-danger small">
                      {formik.touched.transactionDate &&
                        formik.errors.transactionDate}
                    </div> */}
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t("التاريـخ")}</label>
                    <Form.Control
                      className="form-control  text-center"
                      type="date"
                      name="transactionDate"
                      onChange={formikhandleChange}
                      value={
                        values.transactionDate?.toString()?.split("T")[0] || ""
                      }
                      // isInvalid={!!(touched.transactionDate && errors.transactionDate)}
                    />
                    {/* <div className="text-danger small">
                      {formik.touched.transactionDate &&
                        formik.errors.transactionDate}
                    </div> */}
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      {t("الوحدة التشغيليـة")}
                    </label>
                    <Select
                      isDisabled
                      classNamePrefix="react-select"
                      isLoading={loading6}
                      isSearchable
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find(
                        (f: any) => f.value === formik.values.branchId
                      )}
                      // onChange={(option) => {
                      //   formik.setFieldValue('inventoryId', '');
                      //   formik.setFieldValue('branchId', option?.value || '');
                      // }}
                      placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
                    />
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t("المخزن")}</label>
                    <Select
                      isDisabled
                      classNamePrefix="react-select"
                      isLoading={loading4}
                      isSearchable={true}
                      isClearable
                      options={InventoryOptions}
                      value={InventoryOptions?.find(
                        (f: any) => f.value === values.inventoryId
                      )}
                      // onChange={(option: any) => {
                      //   formik.setFieldValue('inventoryId', option === null ? null : option.value);
                      //   // formik.setFieldValue('subInventoryId', null);
                      // }}
                      placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
                    />
                    <div className="text-danger small">
                      {formik.touched.inventoryId && formik.errors.inventoryId}
                    </div>
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t("المخزن الفرعي")}</label>
                    <TreeSelect
                      showSearch
                      className="w-100"
                      treeLine
                      placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
                      allowClear
                      treeDefaultExpandAll={false}
                      value={values.subInventoryId}
                      onChange={(option: any) => {
                        formik.setFieldValue(
                          "subInventoryId",
                          option === null ? null : option
                        );
                      }}
                      treeData={TreeSubInventoryData?.filter(
                        (f) => f.parentId === values.inventoryId
                      )}
                      treeNodeFilterProp="title"
                    />
                    <div className="text-danger small">
                      {formik.touched.subInventoryId &&
                        formik.errors.subInventoryId}
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t("نوع الحركة")}</label>
                    <Select
                      isDisabled
                      classNamePrefix="react-select"
                      // isLoading={loading3}
                      isSearchable={true}
                      isClearable
                      options={OptionsTransactionTypes}
                      value={OptionsTransactionTypes.find(
                        (f) => f.value === "AVC"
                      )}
                      // value={OptionsTransactionTypes.find(
                      //   (f) => f.value === values.code
                      // )}
                      // onChange={(option: any) => {
                      //   formik.setFieldValue(
                      //     "code",
                      //     option === null ? null : option.value
                      //   );
                      // }}
                      placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
                    />
                    <div className="text-danger small">
                      {formik.touched.code && formik.errors.code}
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-3">
                    <label className="form-label">{t("Note")}</label>
                    <Form.Control
                      autoComplete="off"
                      className="form-control"
                      as="textarea"
                      rows={1}
                      name="description"
                      onChange={formik.handleChange}
                      value={values.description}
                    />
                  </div>
                </div>
              </div>

              <div className="row m-0 p-0">
                {values.inventoryId && (
                  <div className="bg-inverse bg-opacity-5 p-2 position-relative">
                    <UpdateCostLines formik={formik} />
                  </div>
                )}
              </div>

              <div className="text-center mt-4">
                <button
                  disabled={formik.isSubmitting}
                  type="submit"
                  className="btn btn-lg me-1 btn-theme mb-1"
                >
                  {formik.isSubmitting ? (
                    <div className="spinner-border spinner-border-sm me-2"></div>
                  ) : (
                    <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
                  )}
                  {t("Add")}
                </button>
                <button
                  type="button"
                  className="btn btn-lg  me-1 btn-default mb-1"
                  onClick={() => Navigate(-1)}
                >
                  <i className="fa fa-power-off fa-fw me-1"></i> {t("Cancel")}
                </button>
              </div>
            </Form>
          </CardBody>
        </Loading>
      </Card>
    </>
  );
};

export default Update;

// <NeatixModal
// show={showModal}
// setShow={setShowModal}
// size="md"
// bodyClassName="p-0"
// showHeader={false}
// keyboard={false}
// backdrop={true}
// >
// <Card>
//   <CardBody>
//     <div className="row">
//       {/* Operating Unit Selection */}
//       <div className="col-lg-12">
//         <div className="form-group mb-3">
//           <label className="form-label">{t("الوحدة التشغيليـة")}</label>
//           <Select
//             classNamePrefix="react-select"
//             isLoading={loading6}
//             isSearchable
//             isClearable
//             options={OperatingUnitOptions}
//             value={OperatingUnitOptions?.find(
//               (f: any) => f.value === formik.values.branchId
//             )}
//             onChange={(option) => {
//               formik.setFieldValue("inventoryId", "");
//               formik.setFieldValue("branchId", option?.value || "");
//             }}
//             placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
//           />
//         </div>
//       </div>

//       {/* Inventory Selection */}

//       <div className="col-lg-12">
//         <div className="form-group mb-3">
//           <label className="form-label">{t("المخزن")}</label>
//           <Select
//             classNamePrefix="react-select"
//             isLoading={loading4}
//             isSearchable
//             isClearable
//             options={InventoryOptions?.filter(
//               (f: any) => f.operatingUnitId === formik.values.branchId
//             )}
//             value={
//               formik.values.inventoryId &&
//               InventoryOptions?.find(
//                 (f: any) => f.value === formik.values.inventoryId
//               )
//             }
//             onChange={(option) =>
//               formik.setFieldValue("inventoryId", option?.value || null)
//             }
//             placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
//           />
//         </div>
//       </div>
//     </div>
//     <div className="row">
//       <div className="col-6">
//         <button
//           type="button"
//           className="btn btn-lg btn-theme  w-100 rounded-0"
//           // onClick={handleSubmitModal}
//           onClick={() => setShowModal(false)}
//           disabled={
//             !formik.values.branchId || !formik.values.inventoryId
//           }
//         >
//           <i className="fas fa-lg fa-fw me-2 fa-check-circle"></i>
//           {t("إختيار")}
//         </button>
//       </div>
//       <div className="col-6">
//         <button
//           type="button"
//           className="btn btn-lg  btn-default  w-100 rounded-0"
//           onClick={() =>
//             Navigate("/INV/Transactions/InvIssue", { replace: true })
//           }
//         >
//           <i className="fas fa-times-circle fa-fw me-1"></i>{" "}
//           {t("Cancel")}
//         </button>
//       </div>
//     </div>
//   </CardBody>
// </Card>
// </NeatixModal>
